import e from"./UrlParams.vue_rollup-plugin-vue_script.vue.js";import d from"../../node_modules/vue-runtime-helpers/dist/normalize-component.js";var n=d({},undefined,e,undefined,undefined,undefined,void 0,void 0);export{n as default};
